import type {OperationVariables, QueryResult} from '@apollo/client';

/**
 * Unwraps the result of an Apollo lazy-query execute function, throwing on failure.
 *
 * Apollo's lazy-query execute function never rejects — failures resolve with `data`
 * undefined and the failure in `result.error`. Reading `result.data` directly turns
 * failures into empty data and leaves `.catch` handlers unreachable, so unwrap
 * results through this instead.
 */
export default function getLazyQueryData<TData, TVariables extends OperationVariables>(
  result: QueryResult<TData, TVariables>
): TData {
  if (result.error !== undefined) {
    throw result.error;
  }

  if (result.data === undefined) {
    throw new Error('Query resolved without data.');
  }

  return result.data;
}
